import React from 'react';

import AiAssistantSidebar from './assistant_sidebar';
import { StandaloneTools } from './tools/standalone';
import { ToolsProvider } from './tools/context';

import type { Agent, Paths } from './types';

interface Props {
  agents: Agent[];
  currentUser: {
    admin: boolean;
  };
  paths: Paths;
}

export default function AiAssistant({ agents, currentUser, paths }: Props) {
  return (
    <ToolsProvider>
      <AiAssistantSidebar agents={agents} currentUser={currentUser} paths={paths} />
      <StandaloneTools/>
    </ToolsProvider>
  );
}
